import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import {LOCALE_ID, NgModule} from '@angular/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { AppComponent } from './app.component';

import { CoreModule } from './core/core.module';
import { LayoutModule } from './layout/layout.module';
import { RoutesModule } from './routes/routes.module';
import {SpiSharedModule} from './shared/spi.shared.module';
import {BlockUIModule} from 'ng-block-ui';
import {ToastrModule} from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { AgendaComponent } from './routes/backoffice/agenda/agenda.component';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import { MessagerieComponent } from './messagerie/messagerie.component';
import {OwlNativeDateTimeModule} from 'ng-pick-datetime';
import * as fr from '@angular/common/locales/fr';


@NgModule({
  declarations: [
    AppComponent,
    MessagerieComponent
  ],
  imports: [
    HttpClientModule,
    BrowserAnimationsModule, // required for ng2-tag-input
    CoreModule,
    LayoutModule,
    SpiSharedModule.forRoot(),
    BlockUIModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    }), // ToastrModule added
    RoutesModule,
    TranslateModule.forRoot(),
    NgbModule,
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    OwlNativeDateTimeModule
  ],
  providers: [ { provide: LOCALE_ID, useValue: 'fr-FR'} ],
  bootstrap: [AppComponent]
})
export class AppModule { }
